<input type="text" class="form-control" [value]="value" (input)="inputUpdate($event)" [placeholder]="getPlaceholder()"
    [disabled]="disabled" #input>